import React, { createContext, useContext, useState, useEffect } from 'react';
import { getMe } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadUser = async () => {
      const token = localStorage.getItem('jtracker_token');
      if (token) {
        try {
          const response = await getMe();
          setUser(response.data.user);
        } catch (error) {
          localStorage.removeItem('jtracker_token');
          localStorage.removeItem('jtracker_user');
        }
      }
      setLoading(false);
    };
    loadUser();
  }, []);

  const login = (userData, token) => {
    localStorage.setItem('jtracker_token', token);
    localStorage.setItem('jtracker_user', JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('jtracker_token');
    localStorage.removeItem('jtracker_user');
    setUser(null);
  };

  const isAdmin = () => user?.role === 'admin';
  // Revisao 15/07: permissao por modulo (admin ve tudo; sem cargo = sem restricao)
  const can = (module) => {
    if (isAdmin()) return true;
    if (!user?.roleId || !user?.permissions) return true;
    const p = user.permissions[module];
    return Array.isArray(p) && p.includes('view');
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isAdmin, can }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth deve ser usado dentro de AuthProvider');
  return context;
};

export default AuthContext;
